import { createRouter, createWebHistory } from "vue-router";
import TheContainer from "@/containers/TheContainer";

const routes = [
  {
    path: "",
    name: "Container",
    component: TheContainer,
    redirect: "/fa",
    children: [
      {
        path: ":lang",
        name: "Home",
        component: () => import("@/views/home/HomeView"),
      },
      {
        path: "/fa/asideHome",
        name: "AsideHome",
        component: () => import("@/views/asideHome"),
      },
      {
        path: "/fa/sound",
        name: "FarsiSounds",
        meta: { title: "صوت ها" },
        component: () => import("@/views/sound"),
      },
      {
        path: "/fa/sound/:id/:sountId?/:title?",
        name: "FarsiSound",
        meta: { title: "صوت" },
        component: () => import("@/views/sound/SoundPage"),
      },
      {
        path: "fa/aboutus",
        name: "FarsiAboutUs",
        meta: { title: "درباره ما" },
        component: () => import("@/views/aboutUs"),
      },
      {
        path: "fa/contactus",
        name: "FarsiContactUs",
        meta: { title: "ارتباط سریع و آسان" },
        component: () => import("@/views/contactUs"),
      },
      {
        path: "fa/posts",
        name: "FarsiPosts",
        meta: { title: "اخبار" },
        component: () => import("@/views/posts"),
      },
      {
        path: "fa/posts/:id/:title?",
        name: "FarsiBlog",
        component: () => import("@/views/posts/BlogPage"),
      },
      {
        path: "fa/search/:filter?",
        name: "FarsiSearch",
        meta: { title: "نتایج جستجو" },
        component: () => import("@/views/search"),
      },
      {
        path: "/fa/media",
        name: "FarsiMedias",
        component: () => import("@/views/media"),
      },
      {
        path: "/fa/media/:id/:mediaId?/:title?",
        name: "FarsiMedia",
        component: () => import("@/views/media/MediaPage"),
      },
      {
        path: "/fa/library",
        name: "FarsiLibraries",
        component: () => import("@/views/library"),
      },
      {
        path: "/fa/library/:id/:title?",
        name: "FarsiLibrary",
        component: () => import("@/views/library/LibraryPage"),
      },
      {
        path: "/fa/photo",
        name: "FarsiPhotos",
        component: () => import("@/views/photo"),
      },
      {
        path: "/ar/photo",
        name: "ArabicPhotos",
        component: () => import("@/views/photo"),
      },
      {
        path: "/fa/photo/:id/:title?",
        name: "FarsiPhoto",
        component: () => import("@/views/photo/PhotoPage"),
      },
      {
        path: "/ar/photo/:id/:title?",
        name: "ArabicPhoto",
        component: () => import("@/views/photo/PhotoPage"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

let language = "fa";
router.beforeEach((to, from, next) => {
  const lang = to.params.lang || language;
  language = lang;
  document.documentElement.lang = lang;
  next();
});

export default router;
